import generalSettings from 'pages/generalSettings'

export default [
  { path: '/general-settings', name: 'generalSettings', component: generalSettings, meta: {permits: ['super_admin']}},
]
